import { useState } from "react";
import { Alert, Button, Modal } from "react-bootstrap";
import { FiX, FiAlertTriangle } from "react-icons/fi";
import { cancelSubscription } from "../../../api/payment";
import { useMutation, useQueryClient } from "react-query";
import { ISubscription } from "../../../models/subscription";
import SpinnerFullSection from "../../Other/SpinnerFullSection";

type Props = {
    show: boolean;
    onClose: () => void;
    subscription?: ISubscription;
};
function CancelSubscription({ show, onClose, subscription }: Props) {
    const [error, setError] = useState<string>();

    const onHide = () => {
        setError(undefined);
        onClose();
    };

    const queryClient = useQueryClient();
    const mutation = useMutation(cancelSubscription, {
        onSuccess: () => {
            queryClient.invalidateQueries("Subscription");
            queryClient.invalidateQueries(["Organizations"]);
            setError(undefined);
            onClose();
        },
        onError: () => {
            setError("Unable to process payment.");
            onClose();
        },
    });

    const handleCancel = () => {
        if (!subscription) {
            return;
        }
        mutation.mutate({
            orgId: subscription.organizationId,
            subscriptionId: subscription.id,
        });
    };
    return (
        <Modal show={show} onHide={onHide} size="lg">
            <Modal.Header closeButton className="bg-danger text-white border-0">
                <Modal.Title className="d-flex align-items-center">
                    <FiAlertTriangle className="me-3" size={24} />
                    Cancel Subscription
                </Modal.Title>
            </Modal.Header>
            <Modal.Body className="p-4 bg-dark text-white">
                {mutation.isLoading && <SpinnerFullSection />}

                <div className="bg-warning bg-opacity-10 p-4 rounded border border-warning mb-4">
                    <h5 className="text-warning fw-bold mb-3">
                        <FiAlertTriangle className="me-2" size={20} />
                        Important Information
                    </h5>
                    <p className="text-light mb-3">
                        If you continue, your subscription will be cancelled,
                        and your service will stop at the end of your current
                        billing period
                        {subscription &&
                            ` on ${new Date(subscription.endAt).toDateString()}`}
                        .
                    </p>
                    <p className="text-light mb-0">
                        You will no longer have access to the features or
                        benefits of your subscription after this date unless you
                        resume or reactivate your subscription.
                    </p>
                </div>

                {error && (
                    <Alert variant="danger" className="border-0">
                        {error}
                    </Alert>
                )}
            </Modal.Body>
            <Modal.Footer className="bg-dark border-0 p-4">
                <Button
                    variant="outline-secondary"
                    onClick={onHide}
                    className="px-4"
                >
                    Keep Subscription
                </Button>
                <Button
                    variant="danger"
                    onClick={handleCancel}
                    className="px-4 fw-semibold"
                >
                    <FiX className="me-2" size={16} />
                    Cancel Subscription
                </Button>
            </Modal.Footer>
        </Modal>
    );
}

export default CancelSubscription;
